<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="cachedViews">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <!-- [LOG] 移除 stagewise toolbar 相关代码：<StagewiseToolbar v-if="isDevelopmentMode" :config="stagewiseConfig" /> -->
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import router from './router'
import { useAuthStore } from '@/stores/authStore'
// [LOG] 移除 stagewise toolbar 相关代码：import { StagewiseToolbar } from '@stagewise/toolbar-vue';

const authStore = useAuthStore()

const route = useRoute()

// 需要缓存的路由组件
const cachedViews = computed(() => {
  return route.matched.filter((item) => item.meta?.keepAlive).map((item) => item.name)
})

// [LOG] 移除 stagewise toolbar 相关代码：stagewiseConfig、isDevelopmentMode 变量

onMounted(() => {
  authStore.initToken()

  if (authStore.token) {
    authStore.fetchUserInfo()
  }
  // 预加载常用组件
  router.preloadComponents()

  // 防抖函数
  // const debounce = (callback, delay) => {
  //   let timer = null
  //   return function (...args) {
  //     if (timer) {
  //       clearTimeout(timer)
  //     }
  //     timer = setTimeout(() => {
  //       callback.apply(this, args)
  //     }, delay)
  //   }
  // }

  // 重写ResizeObserver，添加防抖处理
  // const _ResizeObserver = window.ResizeObserver
  // window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  //   constructor(callback) {
  //     callback = debounce(callback, 20)
  //     super(callback)
  //   }
  // }
})
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, 'microsoft yahei', arial, STHeiTi, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100vh;
  width: 100vw;
  overflow: auto;
}

a {
  text-decoration: none;
  color: inherit;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
